'use strict';

var ShowHideButton = function(passwordSection) {
  var _this = this;
  _this.passwordInput = passwordSection.querySelectorAll('input[type=password]')[0];
  _this.passwordHidden = true;
  _this.toggleButton = document.createElement('button');
  _this.toggleButton.type = 'button';
  _this.showText = 'Show password';
  _this.hideText = 'Hide password';
  _this.toggleText = document.createTextNode(_this.showText);

  _this.toggleButton.addEventListener('click', function(e) {

    if (_this.passwordHidden === true) {
      // show password
      _this.passwordInput.setAttribute('type', 'text');
      _this.toggleText.nodeValue = _this.hideText;
      _this.passwordHidden = false;
    } else {
      // hide password
      _this.passwordInput.setAttribute('type', 'password');
      _this.toggleText.nodeValue = _this.showText;
      _this.passwordHidden = true;
    }

    e.preventDefault();
  });

  _this.toggleButton.appendChild(_this.toggleText);

  _this.toggleButton.classList.add('show-hide-password-button');

  passwordSection.appendChild(_this.toggleButton);
};

function init() {
  var passwordSections = document.querySelectorAll(
    '.password-form-field, .new-password-form-field');

  [].forEach.call(passwordSections, function(passwordSection) {
    new ShowHideButton(passwordSection);
  });
}

if ('querySelector' in document) {
  init();
}
